<template>
<div :style="appStyle">
  <!-- User Dialog -->
  <user :visible.sync="userVisible"></user>

  <el-dialog :visible.sync="configVisible" @close="updateConfiguration">
    <div id="jsoneditor" style="width: 500px; height: 500px;"></div>
  </el-dialog>

  <!-- Head pictures -->
  <div style="width:800px; background-color: #575757">
    <div style="width:800px;height:80px"><img src="./assets/top/top-bg7.jpg"></div>
    <div style="position:relative;width:800px;height:30px">
      <div style="position:absolute;left:28px;bottom:5px;color:white;font-size:11px">
        <span v-if="!$store.state.user" @click="userVisible=true" class="user-button">Login</span>
        <span v-else @click="userVisible=true" v-text="$store.state.user.username" class="user-button"></span>

        <span style="padding-left:20px" v-if="$store.state.user" class="user-button"><a style="color:white" target="_blank" :href="`${$store.state.host}/dokhlab/files`">Files</a></span>
        <span style="padding-left:20px" v-if="Number($store.state.user.level) === 10" class="user-button"><a style="color:white" target="_blank" :href="`${$store.state.host}/dokhlab/pma`">Database</a></span>
        <!--
        <span style="padding-left:20px" v-if="Number($store.state.user.level) === 10" class="user-button"><a style="color:white" target="_blank" :href="`${$store.state.host}/dokhlab/seafile`">Seafile</a></span>
        -->
        <span style="padding-left:20px" v-if="Number($store.state.user.level) === 10" class="user-button"><a style="color:white" target="_blank" @click="showConfiguration">Configuration</a></span>
      </div>
      <img src="./assets/Head.gif">
    </div>
  </div>

  <!-- Menu -->
  <div id="menu">
    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/home">
        <img src="./assets/menuimages/home.png">
      </a>
    </div>

    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/members">
        <img src="./assets/menuimages/members.png">
      </a>
    </div>

    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/research">
        <img src="./assets/menuimages/research.png">
      </a>
    </div>

    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/publications">
        <img src="./assets/menuimages/publications.png">
      </a>
    </div>

    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/tools">
        <img src="./assets/menuimages/tools.png">
      </a>
    </div>

    <div :style="topNavItemStyle" class="top-nav-item">
      <a href="#/events">
        <img src="./assets/menuimages/events.png">
      </a>
    </div>

    <!--
    <div :style="topNavItemStyle" class="top-nav-item" v-if="$store.state.user">
      <a href="#/intranet">
        <img src="./assets/menuimages/intranet.png">
      </a>
    </div>
    -->

    <div style="clear:both"></div>
  </div>

  <div style="width:800px">
    <keep-alive exclude="[Home,Member]">
      <router-view/>
    </keep-alive>
  </div>

</div>
</template>

<script>
import { bus } from './bus.js'
import User from '../User'
import axios from 'axios'
import JSONEditor from 'jsoneditor/dist/jsoneditor.min.js'

export default {
  name: 'app',

  data () {
    return {
      formLabelWidth: 150,
      userVisible: false,
      configVisible: false,
      editor: ''
    }
  },

  computed: {
    topNavItemStyle () {
      let style = {
        margin: '5px 22px'
      }
      if (this.$store.state.user) {
        style.margin = '5px 13px'
      }
      return style
    },

    appStyle () {
      var v = this
      var style = {
        width: '800px'
      }
      var align
      try {
        align = v.frontConfig.layout.align
      } catch (error) {
        align = 'left'
      }
      if (align === 'center') {
        style.margin = '0px auto'
      } else if (align === 'right') {
        style.marginLeft = 'auto'
        style.marginRight = '0px'
      } else {
        style.marginLeft = '0px'
      }
      return style
    },

    frontConfig () {
      return this.$store.state.frontConfig
    }
  },

  components: {
    User
  },

  methods: {
    redirect (url) {
      window.location.href = url
    },

    updateConfiguration () {
//      console.log(this.editor.get())
      this.$store.dispatch('updateFrontConfig', this.editor.get())
    },

    showConfiguration () {
      this.configVisible = true
      this.$nextTick(() => {
        if (!this.editor) {
          console.log(JSONEditor)
          const container = document.getElementById("jsoneditor")
          const options = {}
          this.editor = new JSONEditor(container, options)
          this.editor.set(this.frontConfig)
        }
      })
    }
  },

  mounted () {
    var v = this

    // Initialize front-end configuration
    axios({
      method: 'get',
      url: `${this.$store.state.host}/dokhlab/actions/front_config`,
      withCredentials: true
    }).then(response => {
//      console.log(response.data)
      v.$store.commit('setFrontConfig', response.data)
    }).catch(() => {
      alert(`Could not fetch website front-end configuration`)
    })

    bus.$on('switch-router', (name) => {
      v.active = name
    })
    bus.$on('switch-task', (id) => {
      v.task_id = id
    })
    var top = (document.body.clientHeight - 600) / 2
    var left = (document.body.clientWidth - 1000) / 2
    v.top = (top < 0 ? 0 : top)
    v.left = (left < 0 ? 0 : left)

    // Auto-Login
    this.$store.dispatch('autoLogin')
  }
}
</script>

<style>
@import "~jsoneditor/dist/jsoneditor.min.css";

html {
  overflow-y: auto;
  width: 100%;
  height: 100%;
  /*
  background: url('./assets/app-bg.jpg') no-repeat 50%;
  */
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

img {
  margin: 0px;
}

#menu {
  text-align: center;
}

#menu img {
  display: block;
  height: 100%;
  width: auto;
}

body {
  margin: 8px;
  padding: 0px;
}

#app {
  margin: 0px;
  padding: 0px;
  width: 100%;
  height: 100%;
  position: relative;
}

table {
  height: 100%;
  width: 100%;
  border-collapse:collapse;
  overflow: hidden;
}

tr {
  width: 100%;
  height: 100%;
  margin: 0px;
}

.nav {
  height: 100%;
  width: 250px;
  min-width: 250px;
  background: #2e3238;
  color: white;
  padding: 0px;
  vertical-align: text-top;
}

.nav-header {
  margin: 20px;
  line-height: 40px;
  vertical-align: middle;
}

.content {
  background-color: white;
  align: center;
  padding: 0px;
  overflow-y: auto;
  position: relative;
  /*
  background-image: url('./assets/intro-bg.png');
   */
background-repeat: no-repeat;
background-position: 0px 0px;
background-size: auto 220px;
}

.content-content {
  width: 720px;
  height: 600px;
  margin: 0px auto;
}

/*
.zoom {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 18px;
  color: #878d99;
  cursor: pointer;
  z-index: 99;
}
 */

.left-nav {
  margin-bottom: 0px;
}

.box-card {
  padding: 0px 0px;
}

a {
  text-decoration: None;
}

ul {
  list-style: None;
  padding-left: 0px;
  margin: 0px;
}

li.menu-item {
  padding: 0 20px;
  font-size: 14px;
  /*color: #2d2f33;*/
  height: 56px;
  line-height: 56px;
  cursor: pointer;
}

.submenu-list li.menu-item {
  padding: 0 40px;
}

li.menu-item:hover {
  /*background-color: #ecf5ff*/
}

li.menu-item.is-active {
  /*
  color: #ffd04b;
   */
font-weight: bold;
color: #67c23a;
}

li.menu-item * {
  vertical-align: middle;
}

li.menu-item i {
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
  color: #878d99;
}

li.menu-item.is-active i {
  color: inherit;
}

.submenu-title {
  position: relative;
}

li.menu-item i.submenu-arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -7px;
  font-size: 12px;
}

#bg {
  margin: 0px 0px 10px 0px;
}

div.el-card__header {
  padding: 0px 20px;
  /*
  background-color: #223e4a;
  color: white;
   */
}

.grey-button {
  color: #5a5e66;
}

.unselectable {
  -moz-user-select: -moz-none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

a {
  color: rgb(144, 147, 153);
}

a:hover {
  color: rgb(144,147,153);
}

a:visited {
  color: rgb(144, 147, 153);
}

.el-button--text {
  color: #67c23a;
}

a.jn-button {
  color: #67c23a;
  /*
  color: #67c23a;
   */
cursor: pointer;
font-size: 14px;
font-weight: 600;
display: inline-block;
line-height: 1;
border: 1px solid transparent;
background: transparent;
padding: 12px 0px;
}

a:hover.jn-button {
  /*
  color: #ad8134;
   */
color: #b5e7a0;
}

a:visited.jn-button {
  color: #67c23a;
}

.user-button {
  cursor: pointer;
}

.user-button:hover {
  text-decoration: underline;
}

.greybox {
  text-align: justify;
  text-justify: inter-word;
  background: #EEEEEE;
  border: 1px solid #BBBBBB;
  font-size: 13px;
  font-family: Geneva, arial, helvetica, sans-serif;
  padding: 5px;
  margin: 5px;
}

.top-nav-item {
  float: left;
  padding: 0px;
  height: 25px;
  width: auto;
  opacity: 1;
}

.top-nav-item:hover {
  opacity: 0.7;
}

.top-nav-item a {
  outline: 0;
}

</style>

